import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import { cn } from '@/shared/lib/utils';

/**
 * Checkbox — espelho visual do design system.
 *
 * Fundo e borda precisam ser classes, não styles inline: o estado marcado do
 * Radix usa seletores `data-state`, que precisam conseguir sobrescrevê-los.
 */

export const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, style, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer inline-flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-[5px] outline-none transition-all',
      'border-[1.5px] border-[var(--line-3)] bg-[var(--surface-2)]',
      'data-[state=checked]:border-[var(--brand)] data-[state=checked]:bg-[var(--brand)]',
      'focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-1',
      'disabled:cursor-not-allowed disabled:opacity-50',
      className,
    )}
    style={style}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className="flex items-center justify-center"
      style={{ color: 'var(--bg)' }}
    >
      <Check size={13} strokeWidth={3} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = 'Checkbox';
